export enum ModesEnseignement {
  Regulier = 'REGULIER',
  Stage = 'STAGE',
  StageResidenceMedecine = 'STAGE_RESIDENCE_MEDECINE',
  EducationContinue = 'EDUCATION_CONTINUE',
}
